import type { CustomIconProps } from '../CustomIcon';

export const DocumentsIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  unfilled,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M16.3326 0.923096L22.7711 7.56925V20.8616C22.7711 21.4491 22.545 22.0126 22.1425 22.4281'
        stroke={secondaryColor}
        strokeWidth='1.60962'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.577 0.923096H3.99235C3.42315 0.923096 2.87727 1.1565 2.47479 1.57197C2.0723 1.98743 1.84619 2.55092 1.84619 3.13848V20.8616C1.84619 21.4491 2.0723 22.0126 2.47479 22.4281C2.87727 22.8435 3.42315 23.0769 3.99235 23.0769H16.8693C17.4385 23.0769 17.9843 22.8435 18.3868 22.4281C18.7893 22.0126 19.0154 21.4491 19.0154 20.8616V7.56925L12.577 0.923096Z'
        fill={color}
      />
      <path d='M12.5769 0.923096V4.24617V7.56925H19.0154L12.5769 0.923096Z' fill={secondaryColor} />
    </svg>
  );
};
